import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';

import Page from 'src/shared/ui/components/Page';
import DailyCashClosureForm from 'src/daily-cash-closure/ui/components/DailyCashClosureForm';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  saveButton: {
    top: '-20px'
  },
  backButton: {
    top: '-20px',
    marginRight: theme.spacing(1)
  },
  scrollBox: {
    overflow: 'scroll',
    height: '80vh'
  }
}));

const DailyCashClosureFormView = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { dailyCashClosureId } = useParams();

  const handleCancel = () => {
    navigate('/app/daily-cash-closures');
  };

  return (
    <Page className={classes.root} title="Cierre diario">
      <DailyCashClosureForm
        cancel={handleCancel}
        dailyCashClosureId={dailyCashClosureId}
      />
    </Page>
  );
};

export default DailyCashClosureFormView;
